var path = 'app/scripts/modules/ecs/pipeline/stages/cloneServerGroup/cloneServerGroupStepLabel.html';
var html = "<span class=\"task-label\">\n  Clone Server Group:\n  {{step.context.source.serverGroupName}}\n  ({{step.context.region}})\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/ecs/pipeline/stages/cloneServerGroup/cloneServerGroupStepLabel.html
// module id = 3955
// module chunks = 0